import script from "./RecordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDialog.vue?vue&type=script&setup=true&lang=js"

import "./RecordDialog.vue?vue&type=style&index=0&id=4ec44078&lang=css"

const __exports__ = script;

export default __exports__